import React, { useState, useEffect } from "react";
import FormLogin from "../components/login/FormLogin";
import ApiCall from "../constants/Api";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";
import Dashboard from "./Dashboard";
import SiteConfig from "../constants/SiteConfig";
import ErrorCodes from "../constants/ErrorCodes";
import { WebSocketProvider } from "../services/WebSocketProvider";
import ChangeUserPassword from "../components/utilities/ChangeUserPassword";
import { successMsg } from "../components/SuccessHandler";
import MessagesConfig from "../constants/MessagesConfig";

const Login = () => {
  let loginInit = JSON.parse(localStorage.getItem("loginInfo")) || {
    Session: "",
  };

  const [loginInfo, setLoginInfo] = useState(loginInit);

  let loginPlayerInit = JSON.parse(localStorage.getItem("loginPlayerInfo")) || {
    IdPlayer: 0,
  };
  const [loginPlayerInfo, setLoginPlayerInfo] = useState(loginPlayerInit);
  let statisticsPlayerInit = JSON.parse(
    localStorage.getItem("statisticsPlayer"),
  ) || {
    statisticsPlayerInit: {},
  };
  const [statisticsPlayer, setStatisticsPlayer] =
    useState(statisticsPlayerInit);
  let tracksInfo = JSON.parse(localStorage.getItem("TracksInfo")) || {
    thoroughbredList: [],
    harnessList: [],
    greyList: [],
    trackList: [],
  };
  const [stateTracks, setStateTracks] = useState(tracksInfo);
  let publicIPInit = localStorage.getItem("publicIP") || {
    publicIPInit: {},
  };
  const [publicIP, setPublicIP] = useState(publicIPInit);
  let dateServerDB = {};
  try {
    dateServerDB = JSON.parse(localStorage.getItem("dateServer")) || {
      dateServer: "",
    };
  } catch (e) {
    console.error("Error parsing JSON from localStorage:", e);
    dateServerDB = { dateServer: "" };
  }
  const [dateServer, setDateServer] = useState(dateServerDB);
  const [sessionNoLongerExists, setSessionNoLongerExists] = useState(false);
  const [pingStatusOk, setPingStatusOk] = useState(false);
  let loginUUID = localStorage.getItem("UUID") || "";
  const [loginInfoUUID, setLoginInfoUUID] = useState(loginUUID);
  const [isLoading, setIsLoading] = useState(true);
  const [dialogPingVisible, setDialogPingVisible] = useState(false);
  const [change, setChange] = useState(false);
  const [changePasswordStatus, setChangePasswordStatus] = useState(false);
  const [newUserPassword, setNewUserPassword] = useState({
    user: "",
    password: "",
  });

  useEffect(() => {
    if (changePasswordStatus) {
      successMsg("Password has been changed successfully");
      setChangePasswordStatus(false);
    }
  }, [changePasswordStatus]);

  const getMyIP = async () => {
    const res = await helpAxios("", ApiCall.GET_MY_IP, {});

    if (res.error) {
      let errorDet;
      if (res.errorDetails) {
        errorDet = res.errorDetails;
      }
      errorHandler("GET MY IP: " + res.error, errorDet);
    } else {
      setPublicIP(res.IP);
      localStorage.setItem("publicIP", res.IP);
    }
    return res;
  };

  // Function to obtain the date from the server
  const getDateServer = (date) => {
    var dateServer = new Date(date);
    return (
      dateServer.getFullYear() +
      "-" +
      ("0" + (dateServer.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + dateServer.getDate()).slice(-2)
    );
  };

  // Function to obtain server time
  const getTimeServer = (time) => {
    var timeServer = new Date(time);
    return (
      ("0" + timeServer.getHours()).slice(-2) +
      ":" +
      ("0" + timeServer.getMinutes()).slice(-2) +
      ":" +
      ("0" + timeServer.getSeconds()).slice(-2)
    );
  };

  //Función para obtener la hora de un formato UTC
  const getTimeUTCFormat = (time) => {
    var timeServer = new Date(time);
    return (
      ("0" + timeServer.getUTCHours()).slice(-2) +
      ":" +
      ("0" + timeServer.getUTCMinutes()).slice(-2) +
      ":" +
      ("0" + timeServer.getUTCSeconds()).slice(-2)
    );
  };

  // Function to obtain the time from a UTC format
  const getDateUTCFormat = (date) => {
    var dateServer = new Date(date);
    return (
      dateServer.getUTCFullYear() +
      "-" +
      ("0" + (dateServer.getUTCMonth() + 1)).slice(-2) +
      "-" +
      ("0" + dateServer.getUTCDate()).slice(-2)
    );
  };

  const onlineResetUserPassword = async (req) => {
    let res;
    try {
      res = await helpAxios("", ApiCall.ONLINE_RESET_USER_PASSWORD, req);

      // Show error message
      if (res.OutParams.Result !== 0) {
        errorHandler(res.error);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return res;
  };

  // Function for consuming the LOGIN USER method
  const userLogin = (form) => {
    setDialogPingVisible(true);
    setPingStatusOk(false);

    const fetchData = async () => {
      const isPingSuccessful = await validatePing();
      if (!isPingSuccessful) {
        setPingStatusOk(false);
        setLoginInfo({ Session: "" });
        setLoginInfoUUID("");
      } else {
        setPingStatusOk(true);
        const resIP = await getMyIP();
        if (resIP.error) {
          let errorDet;
          if (resIP.errorDetails) {
            errorDet = resIP.errorDetails;
          }
          errorHandler(resIP.error, errorDet);
        } else {
          setPublicIP(resIP.IP);
          const { userName, password } = form;

          const res = await helpAxios("", ApiCall.LOGIN, {
            LoginName: userName,
            Password: password,
            PhoneLine: SiteConfig.LOGIN_PHONE_LINE,
            IP: resIP.IP,
            System: SiteConfig.LOGIN_SYSTEM_NAME,
          });

          if (res.error) {
            let errorDet;
            if (pingStatusOk) {
              setDialogPingVisible(false);
            }
            if (res.errorDetails) {
              errorDet = res.errorDetails;
            }

            errorHandler(res.error, errorDet);

            if (res.data.ResetPassword) {
              ChangeUserPassword(
                userName,
                password,
                onlineResetUserPassword,
                setChangePasswordStatus,
                setNewUserPassword,
              );
            }
          } else {
            setLoginInfo({
              ...{ ...res, Session: res.UUID },
              ServerDate: getDateServer(res.ServerTime),
              TimeServer: getTimeServer(res.ServerTime),
            });
            setLoginInfoUUID(res.UUID);

            //Set para mantener el nombre del usuario en sesión
            localStorage.setItem("userName", userName);
            localStorage.setItem("UserRights", JSON.stringify(res.UserRights));
          }
        }
      }
    };

    fetchData();
  };

  useEffect(() => {
    if (change) {
      if (localStorage.getItem("UUID")) {
        setPingStatusOk(true);
      } else {
        localStorage.clear();
        setPingStatusOk(false);
        setLoginInfo(loginInit);
        setLoginInfoUUID("");
      }
      setIsLoading(false);
      setChange(false);
    }
  }, [change]);

  //This useEffect runs when already logged in
  useEffect(() => {
    const handleMessage = (e) => {
      const { data } = e;
      if (
        data?.type === MessagesConfig.SessionMessageTypes.REQUEST_SESSION_STATUS
      ) {
        e.source?.postMessage(
          {
            type: MessagesConfig.SessionMessageTypes.SESSION_STATUS,
            payload: { status: MessagesConfig.MessageStatus.OK },
          },
          e.origin,
        );
        return;
      }
      if (data?.type === MessagesConfig.SessionMessageTypes.SESSION_INIT) {
        setPingStatusOk(true);
        setLoginInfo({ Session: data.payload.UUID });
        setLoginInfoUUID(data.payload.UUID);
        localStorage.setItem("publicIP", data.payload.PublicIP);
        localStorage.setItem("userName", data.payload.User);
        localStorage.setItem("UUID", data.payload.UUID);
        localStorage.setItem(
          "UserRights",
          JSON.stringify(data.payload.UserRights),
        );
        setPublicIP(data.payload.PublicIP);
      }
    };

    const handleStorageChange = async (event) => {
      if (event.key === "UUID") {
        if (event.newValue === "") {
          setLoginInfoUUID("");
          setLoginInfo(loginInit);
        } else {
          setPingStatusOk(true);
          setLoginInfoUUID(event.newValue);
          setLoginInfo({ Session: event.newValue });
        }
      }
    };

    setChange(true);
    setSessionNoLongerExists(false);

    // Stablish a listener of events for message event
    window.addEventListener("message", handleMessage);
    window.addEventListener("storage", handleStorageChange);

    //Clean up purpose for listener. Avoiding memory usage or unexpected behaviors
    return () => {
      window.removeEventListener("message", handleMessage);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  //Service check
  const validatePing = async () => {
    try {
      let resPingSchedule = false,
        resPingAccess = false,
        resPingTicketValidator = false,
        resPingAccountManagement = false,
        resPingHistory = false,
        resPingWagerPost = false;

      const resProxySec = await Ping(ApiCall.PING, "", true);

      if (resProxySec && resProxySec.error) {
        const resLegacy = await Ping(ApiCall.PING_LEGACY, "", true);
        if (resLegacy && resLegacy.error) {
          return false;
        }
      }

      //USER ACCESS PING
      resPingAccess = await Ping(ApiCall.PING, SiteConfig.USER_ACCESS_SVC);

      if (!resPingAccess || resPingAccess.error) {
        resPingAccess = await Ping(
          ApiCall.PING_LEGACY,
          SiteConfig.USER_ACCESS_SVC,
        );
        if (!resPingAccess || resPingAccess.error) {
          return false;
        }
      }

      //SCHEDULE PING
      resPingSchedule = await Ping(
        ApiCall.PING,
        SiteConfig.RACING_SCHEDULE_SVC,
      );

      if (!resPingSchedule || resPingSchedule.error) {
        resPingSchedule = await Ping(
          ApiCall.PING_LEGACY,
          SiteConfig.RACING_SCHEDULE_SVC,
        );
        if (!resPingSchedule || resPingSchedule.error) {
          return false;
        }
      }

      //TICKET VALIDATOR PING
      resPingTicketValidator = await Ping(
        ApiCall.PING,
        SiteConfig.RACING_TICKET_VALIDATOR_SVC,
      );

      if (!resPingTicketValidator || resPingTicketValidator.error) {
        resPingTicketValidator = await Ping(
          ApiCall.PING_LEGACY,
          SiteConfig.RACING_TICKET_VALIDATOR_SVC,
        );
        if (!resPingTicketValidator || resPingTicketValidator.error) {
          return false;
        }
      }

      //ACCOUNT MANAGEMENT PING
      resPingAccountManagement = await Ping(
        ApiCall.PING,
        SiteConfig.ACCOUNT_MGMT_SVC,
      );

      if (!resPingAccountManagement || resPingAccountManagement.error) {
        resPingAccountManagement = await Ping(
          ApiCall.PING_LEGACY,
          SiteConfig.ACCOUNT_MGMT_SVC,
        );
        if (!resPingAccountManagement || resPingAccountManagement.error) {
          return false;
        }
      }

      //HISTORY PING
      resPingHistory = await Ping(ApiCall.PING, SiteConfig.PLAYER_HISTORY_SVC);

      if (!resPingHistory || resPingHistory.error) {
        resPingHistory = await Ping(
          ApiCall.PING_LEGACY,
          SiteConfig.PLAYER_HISTORY_SVC,
        );
        if (!resPingHistory || resPingHistory.error) {
          return false;
        }
      }

      //WAGER POST PING
      resPingWagerPost = await Ping(ApiCall.PING, SiteConfig.WAGER_POST_SVC);

      if (!resPingWagerPost || resPingWagerPost.error) {
        resPingWagerPost = await Ping(
          ApiCall.PING_LEGACY,
          SiteConfig.WAGER_POST_SVC,
        );
        if (!resPingWagerPost || resPingWagerPost.error) {
          return false;
        }
      }

      return true;
    } catch (error) {
      return false;
    }
  };

  //Ping service
  const Ping = async (methodName, serviceName, isProxy) => {
    let response = isProxy
      ? await helpAxios({}, methodName)
      : await helpAxios({}, ApiCall.INVOKE_GET_METHOD, {
          MethodName: methodName,
          ServiceName: serviceName,
        });

    if (!response) return;
    return response;
  };

  const getDBDateServer = (track) => {
    const fetchData = async () => {
      try {
        const res = await helpAxios(
          SiteConfig.ACCOUNT_MGMT_SVC,
          ApiCall.GET_DB_DATE_SERVER,
          {
            IP: publicIP,
          },
          loginInfo.Session,
        );

        if (res.error) {
          let errorDet = res.errorDetails ? res.errorDetails : null;
          if (
            res.Result === ErrorCodes.InvalidSession ||
            res.Result === ErrorCodes.SessionNoLongerExists
          ) {
            setSessionNoLongerExists(true);
          } else {
            errorHandler(res.error, errorDet);
          }
        } else {
          const dbDateServer = getDateServer(res.DBServerTime);
          if (!track) {
            setDateServer(dbDateServer);
            localStorage.setItem("dateServer", JSON.stringify(dbDateServer));
          } else if (
            localStorage.getItem("dateServer") !== JSON.stringify(dbDateServer)
          ) {
            userLogout(false);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  };

  // Function for consuming the LOGOUT USER method
  const userLogout = (closeApp) => {
    setDialogPingVisible(false);
    const fetchData = async () => {
      const res = await helpAxios("", ApiCall.LOGOUT, {}, loginInfo.Session);

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setLoginInfo({ Session: "" });
        localStorage.clear();
        setSessionNoLongerExists(false);
        setStateTracks({
          thoroughbredList: [],
          harnessList: [],
          greyList: [],
          trackList: [],
        });
        setLoginInfoUUID("");
      }
    };
    if (closeApp) {
      localStorage.clear();
      setLoginInfo({ Session: "" });
      setLoginPlayerInfo({ IdPlayer: 0 });
      localStorage.setItem("playerName", "");
      fetchData();
      setStateTracks({
        thoroughbredList: [],
        harnessList: [],
        greyList: [],
        trackList: [],
      });
      setLoginInfoUUID("");
      setSessionNoLongerExists(false);
    }
  };

  useEffect(() => {
    localStorage.setItem("UUID", loginInfoUUID);
  }, [loginInfoUUID]);

  useEffect(() => {
    localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
    localStorage.setItem("publicIP", publicIP);
  }, [loginInfo]);

  useEffect(() => {
    localStorage.setItem("loginPlayerInfo", JSON.stringify(loginPlayerInfo));
  }, [loginPlayerInfo]);

  useEffect(() => {
    localStorage.setItem("statisticsPlayer", JSON.stringify(statisticsPlayer));
  }, [statisticsPlayer]);

  useEffect(() => {
    localStorage.setItem("TracksInfo", JSON.stringify(stateTracks));
  }, [stateTracks]);

  return (
    <>
      {isLoading ? (
        <div></div>
      ) : (
        <>
          {!pingStatusOk || !loginInfoUUID ? (
            <>
              <div className="background-radial">
                <FormLogin
                  loginCall={userLogin}
                  setLoginInfo={setLoginInfo}
                  pingStatusOk={pingStatusOk}
                  dialogPingVisible={dialogPingVisible}
                  setDialogPingVisible={setDialogPingVisible}
                  newUserPassword={newUserPassword}
                />
              </div>
            </>
          ) : (
            <WebSocketProvider idPlayer={loginPlayerInfo.IdPlayer}>
              <Dashboard
                data={loginInfo}
                logout={userLogout}
                dateServer={dateServer}
                getTimeUTCFormat={getTimeUTCFormat}
                getDateUTCFormat={getDateUTCFormat}
                getDBDateServer={getDBDateServer}
                setLoginPlayerInfo={setLoginPlayerInfo}
                loginPlayerInfo={loginPlayerInfo}
                setStateTracks={setStateTracks}
                stateTracks={stateTracks}
                statisticsPlayer={statisticsPlayer}
                setStatisticsPlayer={setStatisticsPlayer}
                publicIP={publicIP}
                setLoginInfo={setLoginInfo}
                sessionNoLongerExists={sessionNoLongerExists}
                setSessionNoLongerExists={setSessionNoLongerExists}
                setLoginInfoUUID={setLoginInfoUUID}
                loginInfoUUID={loginInfoUUID}
              />
            </WebSocketProvider>
          )}
        </>
      )}
    </>
  );
};

export default Login;
